export default function Dock(props: React.PropsWithChildren<{}>) {
  return (
    <div className='fixed bottom-0 left-0 top-0 z-10 w-full bg-slate-900 pr-0.5 shadow sm:w-96'>
      <div className='relative flex h-full flex-col gap-4 overflow-y-auto overflow-x-hidden py-6 pl-4 pr-3 scrollbar scrollbar-thumb-slate-50/90 scrollbar-thumb-rounded-sm scrollbar-w-1.5'>
        {props.children}
      </div>
    </div>
  )
}
